export default function CTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20collage%20of%20fashion%20lifestyle%20products%20including%20cream%20sneakers%2C%20olive%20cap%2C%20leather%20bracelet%2C%20small%20tote%20bag%20and%20a%20soft%20cotton%20scarf%20scattered%20artistically%20on%20warm%20cream%20surface%2C%20analog%20film%20grain%20texture%2C%20editorial%20magazine%20style%2C%20soft%20vintage%20aesthetic%20with%20modern%20touches%2C%20neutral%20tones%20with%20subtle%20warm%20accents%2C%20creative%20editorial%20composition%2C%20no%20text%2C%20no%20people&width=1200&height=600&seq=cta-itaobuy-products-v3&orientation=landscape"
            alt="Prodotti migliori con Itaobuy Spreadsheet"
            className="w-full h-[350px] md:h-[450px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>

          <div className="absolute bottom-0 left-0 right-0 p-8 md:p-14 text-center">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-2 leading-tight">
              Scopri
            </h2>
            <p className="font-heading text-2xl md:text-4xl italic text-white/80 font-light mb-3">
              i prodotti migliori
            </p>
            <p className="font-heading text-3xl md:text-5xl font-bold text-white mb-8">
              con Itaobuy
            </p>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white text-foreground-900 font-semibold text-sm rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              Accedi alla guida completa
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}